import { useEffect, useState } from "react";
const preTest = {
  respondent: 0,
  rate: 0,
};
const postTest = {
  respondent: 0,
  rate: 0,
};
function McSuccessRate({ score }) {
  const [preTesRate, setPreTestRate] = useState(preTest);
  const [postTesRate, setPostTestRate] = useState(postTest);
  useEffect(() => {
    setPreTestRate(score.preTest);
    setPostTestRate(score.postTest);
  }, [score]);
  return (
    <>
      <div className="d-flex align-items-center">
        <div className="small text-inverse text-opacity-50">Pre: {preTesRate.respondent} Res.</div>
        <div className="fs-12px me-2 ms-auto">{preTesRate.rate} %</div>
        <div className="progress progress-xs w-100px" style={{ height: "6px" }}>
          {preTesRate.rate > 80 ? <div className="progress-bar progress-bar-striped bg-theme" style={{ width: preTesRate.rate.toString() + "%" }}></div> : ""}
          {preTesRate.rate <= 80 && preTesRate.rate > 50 ? <div className="progress-bar progress-bar-striped bg-warning" style={{ width: preTesRate.rate.toString() + "%" }}></div> : ""}
          {preTesRate.rate <= 50 ? <div className="progress-bar progress-bar-striped bg-danger" style={{ width: preTesRate.rate.toString() + "%" }}></div> : ""}
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div className="small text-inverse text-opacity-50">Post: {postTesRate.respondent} Res.</div>
        <div className="fs-12px me-2 ms-auto">{postTesRate.rate} %</div>
        <div className="progress progress-xs w-100px" style={{ height: "6px" }}>
          {postTesRate.rate > 80 ? <div className="progress-bar progress-bar-striped bg-theme" style={{ width: postTesRate.rate.toString() + "%" }}></div> : ""}
          {postTesRate.rate <= 80 && postTesRate.rate > 50 ? <div className="progress-bar progress-bar-striped bg-warning" style={{ width: postTesRate.rate.toString() + "%" }}></div> : ""}
          {postTesRate.rate <= 50 ? <div className="progress-bar progress-bar-striped bg-danger" style={{ width: postTesRate.rate.toString() + "%" }}></div> : ""}
        </div>
      </div>
    </>
  );
}
export default McSuccessRate;
